const ASYNC_STATUS = {
  IDLE: "IDLE",
  LOADING: "LOADING",
  FAILED: "FAILED",
};

export default ASYNC_STATUS;
